<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 w-full"
>
  <ui-skeleton class="inline-block h-4 w-[80%] rounded-full" />
  <div class="flex gap-3 items-center">
    <ui-skeleton class="block size-12 rounded-full" />
    <div class="flex-1 flex flex-col gap-2">
      <ui-skeleton class="inline-block h-4 w-[55%] rounded-full" />
      <ui-skeleton class="inline-block h-4 w-[60%] rounded-full" />
    </div>
  </div>
  <div class="grid grid-cols-2 gap-3">
    <ui-skeleton class="block h-8 w-full rounded-md" />
    <ui-skeleton class="h-8 w-full rounded-md" />
  </div>
</div>
